require('./createLocationDialog.less');


class CreateLocationDialogController {
    newLocation;
    newLocationId;
    zones;

    constructor(private $mdDialog, private toastService, private Locations, private Zones){
    }

    $onInit(){
        this.Zones.getZones().$promise.then((results) => {
            this.zones = results;
        }, (error) => {
            this.toastService.parseError(error);
        })
    };

    save (){
        this.Locations.updateLocation({locationId: this.newLocationId}, this.newLocation).$promise.then(() => {
            this.toastService.showSimpleToast("Lokasjon opprettet", 3000);
            this.$mdDialog.hide("created");
        }, (error) => {
            this.toastService.parseError(error);
        });
    };

    hide () {
        this.$mdDialog.hide();
    };
    cancel () {
        this.$mdDialog.cancel();
    };

}


class CreateLocationOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "createLocationDialogController";
    public template: any = require('./createLocationDialog.html');
    bindings: any = { };
}


rkcApp.controller("createLocationDialogController", ['$mdDialog', 'toastService', 'Locations', 'Zones', function ($mdDialog, toastService, Locations, Zones) {
    return new CreateLocationDialogController($mdDialog, toastService, Locations, Zones);
}])
    .component("createLocationDialog", new CreateLocationOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/locations/locationDetails/createLocationDialog/createLocationDialog.ts
 **/